import cx from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/context/srp/ModalContext';

export default function BackgroundOverlay() {
  const { isSearchBarFocused } = useContext(ModalContext);

  return (
    <div
      className={cx(
        'pointer-events-none absolute left-0 top-0 z-[1] h-full w-full bg-blue-7 opacity-0 transition-all duration-300',
        {
          'opacity-20': isSearchBarFocused
        }
      )}
    />
  );
}
